import styled, { keyframes } from 'styled-components';
import { position, rgba, size } from 'polished';
import { AbstractButton } from '../../atoms/AbstractButton/AbstractButton';
import { Icon } from '../../atoms/Icon/Icon';
import { MediaQuery } from '../../../styles/mediaQuery';
import { respondTo } from '../../../styles/helpers/respondTo';
import { typeStyle } from '../../../styles/typeStyle';
import { Ease } from '../../../styles/easing';
import { pseudo } from '../../../styles/helpers/pseudo';
import { TransitionDuration } from '../../../styles/variables';

export const StyledCurrentLocation = styled(AbstractButton)`
  ${typeStyle.large};
  height: 3.75rem;
  position: relative;
  padding-left: 2.25rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: padding-left ${TransitionDuration.Normal} ${Ease.EaseOut};

  &:focus {
    padding-left: 2.5rem;
  }

  @media ${respondTo(MediaQuery.Large)} {
    padding-left: 3.4375rem;

    &:focus {
      padding-left: 3.75rem;
    }
  }
`;

export const loader = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const StyledLoader = styled.div`
  ${typeStyle.large};
  display: flex;
  align-items: center;
  height: 3.75rem;
  margin: 0 1.375rem;
`;

export const StyledSpinner = styled.div`
  ${size('1.5rem')};
  position: relative;
  border-radius: 50%;
  background: ${({ theme }) =>
    `linear-gradient(to right, ${theme.color.blue} 0%, ${rgba(theme.color.blue, 0)} 70%)`};
  animation: ${loader} 2s ${Ease.EaseInOutCirc} infinite;
  transform: translateZ(0);
  overflow: hidden;
  margin-right: 0.625rem;
  &::after {
    ${size('90%')};
    ${pseudo()};
    ${position(0)};
    background: ${({ theme }) => theme.color.white};
    border-radius: 50%;
    margin: auto;
  }
`;

export const StyledLocationArrow = styled(Icon.LocationArrow)`
  ${size('1rem')};
  position: absolute;
  left: 0;
  color: ${({ theme }) => theme.color.blue};

  @media ${respondTo(MediaQuery.Large)} {
    left: 1.25rem;
  }
`;
